import { actionTypes } from '../actions/app.action'

const initialState = {
    app: {},
    user: {},
    account: null,
    theme: 'dark',
    padrao: {
        color_primary: "#12284C",
        color_secondary: "#ffffff",
        cart_bilhete_bg: "#ffffff",
        cart_bilhete_color: "#000000",
        cart_btn_bg: "#ffc107",
        cart_btn_color: "#000000",
        cart_color: "#ffffff",
        question_bg: "#E2F8FF",
        question_color: "#12284C"
    },
    error: {},
    success: false,
    colorsLight: [
        '#3B82F6', // azul principal
        '#f87171', // vermelho
        '#22c55e', // verde
        '#eab308', // amarelo
        '#8b5cf6', // roxo
        '#06b6d4', // ciano
        '#f472b6', // rosa
        '#84cc16', // lime
        '#fb923c', // laranja
        '#6366f1', // indigo
        '#14b8a6', // teal
        '#fde047', // amarelo claro
        '#a855f7', // violeta
        '#0ea5e9', // azul secundário
        '#94a3b8'  // cinza neutro (fallback)
    ],
    colorsDark: [
        '#6fb6ff', // azul (sua base)
        '#f87171', // vermelho
        '#4ade80', // verde
        '#fbbf24', // amarelo
        '#c084fc', // roxo
        '#22d3ee', // ciano
        '#f472b6', // rosa
        '#a3e635', // lime
        '#fb923c', // laranja
        '#818cf8', // indigo
        '#2dd4bf', // teal
        '#fde047', // amarelo claro
        '#e879f9', // violeta
        '#38bdf8', // sky
        '#94a3b8'  // cinza (neutro)
    ]
}

const appReducer = (state = initialState, { type, payload }) => {
    
    switch (type) {

    case actionTypes.INDEX:
        return { ...state, ...payload }

    case actionTypes.UPDATE:
        return {
            ...state,
            app: {
                ...state.app,
                ...payload
            }
        }

    case actionTypes.CHANGE:
        return {
            ...state,
            app: {
                ...state.app,
                ...payload
            }
        }

    case actionTypes.CHANGE_THEME:
        return {
            ...state,
            theme: payload
        }

    case actionTypes.CHANGE_USER:
        return {
            ...state,
            user: {
                ...state.user,
                ...payload
            }
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    default:
        return state
    }
}

export default appReducer